// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"SearchResult_placeholder__1a31x","list":"SearchResult_list__2JtCF"};